import {
  GET_DATA_BY_SEARCH_PARAMS_PRINT_CERTIFICATES,
  SET_SEARCH_PARAMS_PRINT_CERTIFICATES,
} from "../types";

const initialState = {
  searchData: [],
  searchParams: {
    surname: "",
    name: "",
    midname: "",
    apptype: 0,
    appDate: "",
    status: 0,
    section: 0,
    licenseType: 0,
  },
};

export const printCertificatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_PARAMS_PRINT_CERTIFICATES: {
      return {
        ...state,
        searchParams: { ...state.searchParams, ...action.data },
      };
    }
    case GET_DATA_BY_SEARCH_PARAMS_PRINT_CERTIFICATES: {
      return {
        ...state,
        searchData: action.data,
      };
    }
    default:
      return state;
  }
};
